module.exports = __webpack_public_path__ + "static/media/premium-packs-active-light-icon.cd0d486d.svg";